// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import LazyImage from './components/lazyImage.jsx';
import ProjectMenu from './Project'
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';


class ProjectFr extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })
    }

    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='6' />
                <div className='dv_project_body'>
                    <ProjectMenu activeMenu={3} />
                    <div className='dv_project_body_right'>
                        <div className={`flex-col`}>
                            <div className='dv_banner_wrap'><img src={require("./assets/img/projects/106.jpg")} /></div>
                            <div className='dv_contentbodyEs_wrap'>
                                <div className='dv_trake_change flex-row between'>
                                    <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>法国数字技术学院</div>
                                    <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>BACHELOR 本科专业介绍 </div>
                                    <div className={this.state.currentTab == 2 ? 'tab selected tablast' : 'tab clickable'} onClick={() => this.onToggleTab(2)}>MBA 硕士专业介绍</div>
                                </div>
                                {this.state.currentTab == 0 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/projects/65.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/66.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/67.jpg")} />

                                    </div>

                                </div>}
                                {this.state.currentTab == 1 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/projects/68.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/69.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/70.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/71.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/72.jpg")} />
                                    </div>

                                </div>}
                                {this.state.currentTab == 2 && <div className='dv_lazy_body flex-col'>
                                    <div className='flex-col'>
                                        <LazyImage imgUrl={require("./assets/img/projects/73.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/74.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/75.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/76.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/77.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/78.jpg")} />
                                        <LazyImage imgUrl={require("./assets/img/projects/79.jpg")} />
                                    </div>

                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>



        );
    }
}

export default withRouter(ProjectFr);